import { Modal, Button, Divider } from "antd";
import * as React from "react";
import { Layout, Input, TimePicker, Select } from "antd";
import { Formik, FieldProps, Field } from "formik";
import * as moment from "moment";
import styled from "styled-components";
import { AddCategoryIcon } from "./AddCategoryIcon";
import { PictureOutlined } from "@ant-design/icons";
import { WEBURL, AWS_URL } from "../../constant/comman";
import { ColorModal } from "./ColorModal";

const { Content } = Layout;
const Option = Select.Option;

export class EditForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      data: [],
      view: false,
      isLoading: false,
      visible: false,
      changeFile: true,
      view: false,
      selectedType: "",
      background: "#ffffff",
      forground: "#ffffff",
      accent: "#ffffff",
      fieldName: "background",
      errors: {
        uploadImage: "",
        selectedType: "",
      },
    };
  }

  input;
  allTypes = [
    <Option value={"charity"}>Organization</Option>,
    <Option value={"vendor"}>Vendor</Option>,
  ];
  viewModalRef;
  src = "";
  colorModalRef;

  uploadImage = (name) => {
    console.log("!!!!!!!!!!!!!!after upload ", name);
    if (name != null) {
      this.src = name;
      this.setState({
        view: false,
        changeFile: true,
      });
    } else {
      this.setState({
        view: false,
      });
    }
  };

  showViewModal = (params) => {
    this.setState(
      {
        view: true,
      },
      () => {
        this.viewModalRef.show();
      }
    );
  };

  changeFocus = (fieldName) => {
    console.log("!!!!!!changeFocus", fieldName);
    this.setState({ fieldName: fieldName });
    this.setState(
      {
        colorView: true,
      },
      () => {
        this.colorModalRef.show();
      }
    );
  };

  changeColor = (color) => {
    const { fieldName } = this.state;
    if (color) {
      if (fieldName === "background") {
        this.setState({ background: color });
      } else if (fieldName === "forground") {
        this.setState({ forground: color });
      } else {
        this.setState({ accent: color });
      }
    }

    this.setState({
      colorView: false,
    });
  };

  componentDidMount() {
    this.src = this.props.data.icon_name;
    this.iconUrl = this.props.data.icon_url || "";
    console.log("!!!!componentDidMount", this.props.data);

    this.setState({
      selectedType: this.props.data.type,
      background: this.props.data.background
        ? this.props.data.background
        : "#ffffff",
      forground: this.props.data.forground
        ? this.props.data.forground
        : "#ffffff",
      accent: this.props.data.accent ? this.props.data.accent : "#ffffff",
    });
  }

  validateForm(values) {
    const errors = {};
    console.log("Validating form -- ", values);

    if (!values.name) {
      errors.name = "name is required";
    }

    console.log("Validating errors -- ", errors);
    return errors;
  }

  handleSubmit(values, action) {
    const { selectedType, errors } = this.state;
    const dummyErrors = { ...errors };

    if (!selectedType) {
      dummyErrors.selectedType = "Please select Type";
      this.setState({
        errors: dummyErrors,
      });
      return;
    }

    dummyErrors.selectedType = "";
    if (this.src === "") {
      dummyErrors.uploadImage = "Please upload icon for category";
      this.setState({
        errors: dummyErrors,
      });
      return;
    }
    dummyErrors.uploadImage = "";

    if (!this.state.background) {
      dummyErrors.background = "background is required";
      this.setState({
        errors: dummyErrors,
      });
    }
    dummyErrors.background = "";

    if (!this.state.forground) {
      dummyErrors.forground = "forground is required";
      this.setState({
        errors: dummyErrors,
      });
    }
    dummyErrors.forground = "";

    if (!this.state.accent) {
      dummyErrors.accent = "accent is required";
      this.setState({
        errors: dummyErrors,
      });
    }
    dummyErrors.accent = "";

    values.icon_name = this.src;
    values.background = this.state.background;
    values.forground = this.state.forground;
    values.accent = this.state.accent;

    values.type = selectedType;
    this.props.onSubmit(values, this.props.data.id);
    this.props.handleCancel();

    this.setState({
      visible: false,
    });
  }

  changeType = (value) => {
    this.setState({
      selectedType: value,
    });
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  render() {
    console.log("!!!!!!!state ", this.state.background);

    return (
      <div>
        <div>
          <Content style={{ background: "#fff", marginLeft: "10px" }}>
            <Formik
              initialValues={{
                name: this.props.data.name,
                type: this.props.data.type,
                background: this.props.data.background,
                forground: this.props.data.forground,
                accent: this.props.data.accent,
                icon_name: this.props.data.icon_name,
              }}
              validate={this.validateForm}
              onSubmit={this.handleSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setFieldTouched,
                isSubmitting,
              }) => {
                return (
                  <div>
                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        Category Name
                        <Input
                          id="name"
                          placeholder="Category Name"
                          value={values.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.name && touched.name ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.name}
                          </p>
                        ) : null}
                      </div>
                      <div className="formik-field-right">
                        Type
                        <Select
                          allowClear
                          style={{ width: "100%" }}
                          value={this.state.selectedType}
                          onChange={(value) => this.changeType(value)}
                          placeholder="Select Type"
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {this.allTypes}
                        </Select>
                        {this.state.errors.selectedType ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {this.state.errors.selectedType}
                          </p>
                        ) : null}
                      </div>
                    </div>
                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        Card Background Color
                        <Input
                          id="background"
                          placeholder="Card Background Color"
                          value={values.background}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={this.state.background}
                          onClick={() => this.changeFocus("background")}
                        />
                        <div
                          style={{
                            background: this.state.background,
                            width: "20px",
                            height: "20px",
                            marginTop: "5px",
                            borderRadius: "5px",
                          }}
                        />
                        {this.state.errors.background ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {this.state.errors.background}
                          </p>
                        ) : null}
                      </div>
                      <div className="formik-field-right">
                        Text Color
                        <Input
                          id="forground"
                          placeholder="Text Color"
                          value={values.forground}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={this.state.forground}
                          onClick={() => this.changeFocus("forground")}
                        />
                        <div
                          style={{
                            background: this.state.forground,
                            width: "20px",
                            height: "20px",
                            marginTop: "5px",
                            borderRadius: "5px",
                          }}
                        />
                        {this.state.errors.forground ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {this.state.errors.forground}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        Progress Bar Color
                        <Input
                          id="accent"
                          placeholder="Progress Bar Color"
                          value={values.accent}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={this.state.accent}
                          onClick={() => this.changeFocus("accent")}
                        />
                        <div
                          style={{
                            background: this.state.accent,
                            width: "20px",
                            height: "20px",
                            marginTop: "5px",
                            borderRadius: "5px",
                          }}
                        />
                        {this.state.errors.accent ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {this.state.errors.accent}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div>
                      {this.state.colorView ? (
                        <ColorModal
                          refx={(e) => (this.colorModalRef = e)}
                          changeColor={this.changeColor}
                          selectedColor={this.state[this.state.fieldName]}
                        />
                      ) : null}
                    </div>

                    <div
                      style={{
                        display: "inline-block",
                        width: "100%",
                        marginTop: "20px",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ float: "left", width: "10%" }}>
                        <PictureOutlined
                          style={{ width: "100%", fontSize: "30px" }}
                        />
                      </div>
                      <Button
                        style={{ width: "90%" }}
                        onClick={this.showViewModal.bind(this)} //this.showViewModal.bind(this)
                      >
                        Choose Category Icon ( Upload PNG, JPG or JPEG only )
                      </Button>
                      {this.src ? (
                        <p
                          style={{
                            fontSize: "small",
                            margin: "0",
                            marginLeft: "5px",
                          }}
                        >
                          {this.src}
                        </p>
                      ) : null}
                      {this.state.view ? (
                        <AddCategoryIcon
                          refx={(e) => (this.viewModalRef = e)}
                          onUpload={this.uploadImage}
                        />
                      ) : null}
                    </div>
                    <div width="100%" style={{ marginTop: "10px" }}>
                      {this.state.errors.uploadImage != "" ? (
                        <p
                          style={{
                            color: "red",
                            fontSize: "small",
                            margin: "0",
                          }}
                        >
                          {this.state.errors.uploadImage}
                        </p>
                      ) : null}
                    </div>
                    <div
                      style={{
                        marhinTop: "20px",
                        width: "100px",
                        backgroundColor:
                          this.selectedColorType !== ""
                            ? this.selectedColorType
                            : "#ffffff",
                        borderRadius: "10px",
                      }}
                    >
                      {this.src && this.src !== "" ? (
                        <img
                          src={
                            this.state.changeFile
                              ? `${WEBURL}category/icon/${this.src}`
                              : this.iconUrl ||
                                `${AWS_URL}category/icon/${this.src}`
                          }
                          alt="CategoryIcon"
                          style={{ width: "100px" }}
                        />
                      ) : null}
                    </div>

                    <Button
                      type="primary"
                      style={{
                        marginTop: "19px",
                        background: "#5C6AC4",
                        color: "#fff",
                      }}
                      onClick={handleSubmit}
                    >
                      Edit
                    </Button>
                  </div>
                );
              }}
            </Formik>
          </Content>
        </div>
      </div>
    );
  }
}
